import script from "./component-compiler-parent.vue?vue&type=script&lang=js"
export * from "./component-compiler-parent.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__